import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { proJobConst } from '../../../../utils';

@Component({
  selector: 'app-materials-pop-up',
  templateUrl: './materials-pop-up.component.html',
  styleUrls: ['./materials-pop-up.component.scss'],

})
export class MaterialsPopUpComponent implements OnInit {
  proJobConst = proJobConst;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  imageObject = this.data.uploadedPics
  ngOnInit() {}

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/materials-pop-up/materials-pop-up.component.ts